/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('region.ski-resorts')
 */
import { RegionLayout } from 'page-components/region/_layout';

import Component, { getRegionGuidePageServerSideProps } from 'page-components/region/ski-resorts';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchRegionSlugs } from 'util/fetchStaticPageRegion';
import { isMainLocale } from 'util/i18nFlags';
import { packPaths } from 'util/packPaths'; */

export default Object.assign(Component, { Layout: RegionLayout });

// export const Layout = RegionLayout;

export const getServerSideProps = propsWithI18NSSR(getRegionGuidePageServerSideProps);
/*
export const getStaticPaths = async () => packPaths(
  isMainLocale() ? (
    await fetchRegionSlugs('region.ski-resorts')
  ).map((reg) => ({
    region: reg.slug,
  })) : [],
);
*/
